module.exports = __webpack_public_path__ + "img/2_sc_t_logo.eed86a66.svg";